import React, { useState } from "react";

import TextField from "@material-ui/core/TextField";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";

import {
  Grid,
  LinearProgress,
  Select,
  OutlinedInput,
  MenuItem,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import "./index.scss";
// styles
import useStyles from "../../styles";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import { yellow } from "@material-ui/core/colors";

export default function UploadDocuments(props) {
  var classes = useStyles();
  var theme = useTheme();

  function onFileChange() {}

  function onFileUpload(e) {
    e.preventDefault();
  }
  return (
    <form
      className={classes.root + " " + classes.subformsc}
      noValidate
      autoComplete="off"
    >
      <Grid container spacing={0.1}>
        <Grid item md={4} className={classes.toppaddinggridc}>
        <div style={{ flexDirection: "row"}}>
            <label for="files" style={{ fontSize: "0.65rem" }}>
              Driving Licence
            </label>
            <div className={classes.borderdivc} style={window.innerWidth < 500 ?  {width: '100%'} : {width: '80%'}}>
              <button className="upload-Input" style={{ backgroundColor: 'white', borderColor: 'transparent', marginTop: -30, marginLeft: 80}}>
                <div style={{ marginLeft: -100, marginTop: -20 }}>
                  <input className="fileInput" type="file" />
                </div>
              </button>
            </div>
          </div>
        </Grid>
        <Grid item md={8} className={classes.toppaddinggridc}></Grid>

        <Grid item md={4} className={classes.toppaddinggridc}>
        <div style={{ flexDirection: "row"}}>
            <label for="files" style={{ fontSize: "0.65rem" }}>
              Passport Cover
            </label>
            <div className={classes.borderdivc} style={window.innerWidth < 500 ?  {width: '100%'} : {width: '80%'}}>
              <button className="upload-Input" style={{ backgroundColor: 'white', borderColor: 'transparent', marginTop: -30, marginLeft: 80}}>
                <div style={{ marginLeft: -100, marginTop: -20 }}>
                  <input className="fileInput" type="file" />
                </div>
              </button>
            </div>
          </div>
        </Grid>
        <Grid item md={4} className={classes.toppaddinggridc}>
        <div style={{ flexDirection: "row"}}>
            <label for="files" style={{ fontSize: "0.65rem" }}>
              Passport Inside
            </label>
            <div className={classes.borderdivc} style={window.innerWidth < 500 ?  {width: '100%'} : {width: '80%'}}>
              <button className="upload-Input" style={{ backgroundColor: 'white', borderColor: 'transparent', marginTop: -30, marginLeft: 80}}>
                <div style={{ marginLeft: -100, marginTop: -20 }}>
                  <input className="fileInput" type="file" />
                </div>
              </button>
            </div>
          </div>
        </Grid>
        <Grid item md={4} className={classes.toppaddinggridc}>
        <div style={{ flexDirection: "row"}}>
            <label for="files" style={{ fontSize: "0.65rem" }}>
              Passport Inside
            </label>
            <div className={classes.borderdivc} style={window.innerWidth < 500 ?  {width: '100%'} : {width: '80%'}}>
              <button className="upload-Input" style={{ backgroundColor: 'white', borderColor: 'transparent', marginTop: -30, marginLeft: 80}}>
                <div style={{ marginLeft: -100, marginTop: -20 }}>
                  <input className="fileInput" type="file" />
                </div>
              </button>
            </div>
          </div>
          {window.innerWidth > 500 && 
           <p style={{ color: "#1D275A", fontSize: "0.65rem" }}>
           Print on a white paper type the date and sign then they hold the
           passport and paper and take a selfie picture
         </p>}
        </Grid>
        {window.innerWidth < 499 && 
           <p style={{ color: "#1D275A", fontSize: "0.65rem" }}>
           Print on a white paper type the date and sign then they hold the
           passport and paper and take a selfie picture
         </p>}
        {/* <Grid item md={4} className={classes.toppaddinggridc}>
          <div style={{ flexDirection: "row"}}>
            <label for="files" style={{ fontSize: "0.65rem" }}>
              Selfie Picture
            </label>
            <div className={classes.borderdivc} style={window.innerWidth < 500 ?  {width: '100%'} : {width: '80%'}}>
              <button className="upload-Input" style={{ backgroundColor: 'white', borderColor: 'transparent', marginTop: -30, marginLeft: 80}}>
                <div style={{ marginLeft: -100, marginTop: -20 }}>
                  <input
                  
                   className="fileInput" type="file" />
                </div>
              </button>
            </div>
          </div>
          <p style={{ color: "#1D275A", fontSize: "0.65rem" }}>
            Print on a white paper type the date and sign then they hold the
            passport and paper and take a selfie picture
          </p>
        </Grid> */}
      </Grid>
    </form>
  );
}
